import { render, staticRenderFns } from "./DesignerActionBar.vue?vue&type=template&id=97710bb2&scoped=true&"
import script from "./DesignerActionBar.vue?vue&type=script&lang=js&"
export * from "./DesignerActionBar.vue?vue&type=script&lang=js&"
import style0 from "./DesignerActionBar.vue?vue&type=style&index=0&id=97710bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97710bb2",
  null
  
)

export default component.exports